// Generated by CoffeeScript 2.7.0
var generateDataKey,
  indexOf = [].indexOf;

import Utilities from 'helpers/utilities.js';

({generateDataKey} = Utilities);

HTMLElement.prototype.hasClass = function(name) {
  return RegExp(` ${name} `).test(` ${this.className} `);
};

HTMLElement.prototype.addClass = function(name) {
  if (HTMLElement.prototype.hasClass.call(this, name)) {
    return true;
  }
  return this.className = `${this.className} ${name}`.trim();
};

HTMLElement.prototype.removeClass = function(name) {
  if (name === void 0) {
    this.className = '';
    return true;
  }
  if (!HTMLElement.prototype.hasClass.call(this, name)) {
    return true;
  }
  return this.className = ` ${this.className.trim()} `.split(` ${name} `).join(' ').trim();
};

HTMLElement.prototype.toggleClass = function(name) {
  return HTMLElement.prototype[HTMLElement.prototype.hasClass.call(this, name) ? 'removeClass' : 'addClass'].call(this, name);
};

HTMLElement.prototype.closest = function(selector) {
  var body, html, matchesSelector, node;
  body = document.body;
  html = document.documentElement;
  matchesSelector = body.webkitMatchesSelector || body.msMatchesSelector || body.mozMatchesSelector || body.oMatchesSelector;
  node = this;
  // 匹配到或者是匹配到根则结束
  while ((node && !matchesSelector.call(node, selector)) && (node !== html)) {
    node = node.parentNode;
  }
  // 如果查找到html元素也没匹配到，则返回null
  if (node && (node === html) && (!matchesSelector.call(node, selector))) {
    return null;
  } else {
    return node;
  }
};

// EventTarget::proxy = (type, selector, fn) ->
// window.EventTarget does not exist in Safari
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
// http://stackoverflow.com/questions/36675693/eventtarget-interface-in-safari
// HTMLElement << Element << Node << EventTarget
// HTMLDocument << Document << Node << EventTarget
Node.prototype.proxyWithOptions = function(type, {selector, useCapture}, fn) {
  var proxy_fn;
  if (selector) {
    proxy_fn = function(event) {
      if (event._target = event.target.closest(selector)) {
        return fn(event);
      }
    };
  } else {
    proxy_fn = (event) => {
      event._target = this;
      return fn(event);
    };
  }
  // focus 和 blur 事件不冒泡, 代理时需要使用捕获期
  // https://developer.mozilla.org/zh-CN/docs/Web/Events/focus
  useCapture = (type === 'focus') || (type === 'blur') || useCapture;
  // 如果支持touch事件，则使用touch事件取代click事件
  if (type === 'click' && indexOf.call(window, 'ontouchstart') >= 0) {
    type = 'touchend';
  }
  return this.addEventListener(type, proxy_fn, useCapture);
};

Node.prototype.proxy = function(type, selector, fn) {
  if (_.isString(selector)) {
    return this.proxyWithOptions(type, {selector}, fn);
  } else {
    return this.proxyWithOptions(type, {}, selector);
  }
};

HTMLElement.prototype.data = function(attr_name, val) {
  attr_name = generateDataKey(attr_name);
  if (val === void 0) {
    return HTMLElement.prototype.getAttribute.call(this, `data-${attr_name}`);
  } else {
    return HTMLElement.prototype.setAttribute.call(this, `data-${attr_name}`, val);
  }
};

HTMLElement.prototype.removeData = function(attr_name) {
  attr_name = generateDataKey(attr_name);
  return HTMLElement.prototype.removeAttribute.call(this, `data-${attr_name}`);
};

HTMLElement.prototype.css = function(properties = {}) {
  var k, results, v;
  results = [];
  for (k in properties) {
    v = properties[k];
    results.push(this.style[k] = v);
  }
  return results;
};

HTMLElement.prototype.append = function(node) {
  return new DomMaster(this).append(node);
};

HTMLElement.prototype.replaceWith = function(node) {
  return new DomMaster(this).replaceWith(node);
};
